export enum LayoutBuilderTypes {
  HERO_BANNER = 'HeroBannerLayout',
  GENERIC = 'Generic',
  SPLIT_SCREEN = 'SplitScreenLayout',
}

export interface ScreenSplitLayoutProps {
  pageTitle?: string;
  moto?: string;
  desktopBrandLogo?: any;
  mobileBrandLogo?: any;
  logoAlt?: string;
  shouldRemovePadding?: boolean;
  dataTestId: string;
  leftContainerType: SpiltScreenTypes.PUBLIC_APP | SpiltScreenTypes.TERMS_CONDITION;
}

export enum SpiltScreenTypes {
  TERMS_CONDITION = 'TermsCondition',
  PUBLIC_APP = 'PublicApp',
}

export enum HeroBannerTypes {
  DASHBOARD = 'DashBoard',
  CARD_REQUEST = 'CardRequest',
}
